import {LuckyExcel} from "./main"
// export Node module
export = LuckyExcel;